export const EXHIBITION_ABOUT_LABELS = {
	section1: {
		title: 'Are You Exhibiting at Expo West or Newtopia Now?',
		content:
			'As an exhibitor at a New Hope Network show, Beacon Discovery is included in your booth package. As part of our continuing efforts to promote transparency and integrity, our Standards program is expanding to include pre-show reviews. Product information uploaded as part of this review will be concurrently uploaded to Beacon Discovery, to help retailers plan their Expo experience and find you 365 days a year.',
		buttonText: 'Get Started',
		buttonLink: '/getonbeacon'
	},
	section2: {
		title: 'Not Ready to Exhibit at Natural Products Expo?',
		content:
			'Beacon Discovery is available by subscription for all eligible CPG brands, so you can still be discovered by top retailers from Natural Products Expo who are looking for products like yours! All products must meet our New Hope standards and current platform offerings to be eligible for Beacon Discovery. To learn more about our Ingredient and Labeling Standards, click ',
		linkLabel: 'here',
		linkContent: 'https://standards.newhope.com/ingredient-standards-guidelines/',
		buttonText: 'Learn More',
		buttonLink: 'https://beacon.newhope.com/beacon-discovery-annual-subscription/'
	}
};
